<script lang="ts" setup>
import { reactive, ref } from 'vue';
import axiosApiClient from '@/axios';

interface Configuration {
    key: string;
    value: string;
}
const configurations = ref<Configuration[]>([]);
const corporateInfo = ref({
    name: '',
    address: '',
    phone: '',
    mobile: '',
    email: '',
    description: '',
});

const fetchCorporateInfo = async () => {
    let response = await axiosApiClient.get('/api/configurations/general');
    if (response.data) {
        configurations.value = response.data;
        corporateInfo.value.name = configurations.value.find((config: any) => config.key === 'corp_name')?.value || '';
        corporateInfo.value.address = configurations.value.find((config: any) => config.key === 'corp_address')?.value || '';
        corporateInfo.value.phone = configurations.value.find((config: any) => config.key === 'corp_phone')?.value || '';
        corporateInfo.value.mobile = configurations.value.find((config: any) => config.key === 'corp_mobile')?.value || '';
        corporateInfo.value.email = configurations.value.find((config: any) => config.key === 'corp_email')?.value || '';
        corporateInfo.value.description = configurations.value.find((config: any) => config.key === 'corp_description')?.value || '';
    }
};
fetchCorporateInfo();
interface Config {
    key: string;
    value: string;
}
const vm2 = reactive<Config[]>([]);
const fetchvm2 = async () => {
    let mission = await axiosApiClient.get('/api/configurations/mission/by-key');
    let vision = await axiosApiClient.get('/api/configurations/vision/by-key');
    let message = await axiosApiClient.get('/api/configurations/message/by-key');
    if (mission.data) {
        vm2.push(mission.data);
    }
    if (vision.data) {
        vm2.push(vision.data);
    }
    if (message.data) {
        vm2.push(message.data);
    }
};
fetchvm2();
</script>
<template>
    <app-layout>
        <div class="about-page" v-if="corporateInfo.name">
            <h2>
                {{ corporateInfo.name }}
            </h2>
            <h3>
                {{ corporateInfo.address }}
            </h3>
            <h5>
                هاتف : {{ corporateInfo.phone }}
            </h5>
            <h5>
                جوال : {{ corporateInfo.mobile }}
            </h5>
            <h5>
                بريد الكتروني : {{ corporateInfo.email }}
            </h5>
            <!-- Description -->
            <p class="mt-5">
                {{ corporateInfo.description }}
            </p>
            <!-- vision , mission and message -->
            <div class="w-full mt-5" v-if="vm2.length > 0">
                <h3>رؤيتنا</h3>
                <p v-html="vm2[0].value"></p>
                <h3>هدفنا</h3>
                <p v-html="vm2[1].value"></p>
                <h3>رسالتنا</h3>
                <p v-html="vm2[2].value"></p>
            </div>
        </div>
        <div v-else>
            <h2></h2>
        </div>
    </app-layout>
</template>

<style lang="scss" scoped>
.about-page {
    text-align: center;
    padding: 15%;
    font-size: 20px;
    direction: rtl;
    min-height: 40vh;
}
</style>